import React, { Component, useState } from "react";
import { Navigate } from "react-router-dom";
import CartContext from "./CartContext";
import ElasticCartAd from "./ElasticCartAd";

//https://www.c-sharpcorner.com/article/create-different-charts-in-react-using-chart-js-library/
export class Home extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    if (this.context.userData.loginStatus !== "active")
      return <Navigate to="/UserLogin" />;
    return (
      <>
        <ElasticCartAd></ElasticCartAd>
      </>
    );
  }
}
